import { useState } from "react";
import { Popin } from "$components/Popin/Popin";

export const usePopin = () => {
  const [isOpened, setOpen] = useState<boolean>(false);

  const openPopin = () => {
    setOpen(true);
  };

  const togglePopin = () => {
    setOpen(!isOpened);
  };

  const PopinProps = {
    openPopin: isOpened,
    toggleDrawer: togglePopin,
    "data-testid": "popin",
  };

  return {
    Popin,
    PopinProps,
    openPopin,
    togglePopin,
  };
};
